<template>
  <p><router-link :to="{ name: routeName, params: { id: resourceId }}"><b><slot></slot></b></router-link></p>
</template>

<script>
export default {
  props: {
    type: {
      required: true,
      type: String
    },
    resourceId: {
      required: true,
      type: Number
    }
  },
  computed: {
    routeName () {
      let route = ''
      switch (this.type) {
        case 'rider':
          route = 'riders.detail'
          break
        case 'horse':
          route = 'horses.detail'
          break
        default:
          break
      }
      return route
    }
  }
}
</script>
